var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.05 15.55q-.375.15-.712-.062A.68.68 0 0 1 0 14.875V10.45a.73.73 0 0 1 .163-.475.7.7 0 0 1 .412-.25L7.55 8 .575 6.225a.7.7 0 0 1-.412-.25A.73.73 0 0 1 0 5.5V1.125q0-.4.338-.612A.75.75 0 0 1 1.05.45l16.3 6.85q.45.2.45.7t-.45.7z"
})));
export default SvgSendIcon;